import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
  inject
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Subscription, catchError, filter, firstValueFrom, forkJoin, of } from 'rxjs';
import { isNearScrollBottom } from 'src/app/helper/scroll-infinite-load.helper';
import { AiService } from 'src/app/services/ai/ai.service';
import { AiStudioSubscriptionCtaService } from 'src/app/services/ai/ai-studio-subscription-cta.service';
import { QUOTE_MENU } from 'src/app/config/configuration/configuration.constant';
import { ConfigurationService } from 'src/app/config/configuration/service/configuration.service';
import { ChatNotificationComponent } from 'src/app/dialogs/chat-notification/chat-notification.component';
import { RepairIntimationRequestComponent } from 'src/app/dialogs/repair-intimation-request/repair-intimation-request.component';
import { HasPermissionDirective } from 'src/app/helper/directive/has-permission/has-permission.directive';
import { menuItem, menuItems, partialUrlsMatch } from 'src/app/model/menu';
import { ChqCasesTableComponent } from 'src/app/modules/quote/chq-cases/chq-cases-table/chq-cases-table.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common/common.service';
import { InspectionService } from 'src/app/services/inspection/inspection.service';
import { MessagesService } from 'src/app/services/message/message.service';
import { MonitorService } from 'src/app/services/monitor/monitor.service';
import { SignalRService } from 'src/app/services/signalr/signalr.service';
import { UserService } from 'src/app/services/user/user.service';
import { AttendanceService, HrmCheckInState } from 'src/app/services/attendance/attendance.service';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { ClaimAssignModalComponent } from '../claim-assign-modal/claim-assign-modal.component';
import { UserSelectionService } from 'src/app/services/user-selection/user-selection.service';
import { CoreService } from 'src/app/services/core/core.service';
import { OrgAccessService } from 'src/app/services/org-access/org-access.service';
dayjs.extend(relativeTime);
dayjs.extend(isToday);

const caseIndexMapper = {
  draft: 1,
  vehicledetails: 2,
  uploaddocuments: 3,
  uploadphotos: 4,
  aianalysis: 4,
  repairestimation: 5,
  approved: 6,
  rejected: 6,
  closed: 6,
  complete: 6
};
const HRM_CLOCK_IN_REMINDER_DELAY_MS = 5 * 60 * 1000;

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements AfterViewInit, OnDestroy, OnInit {
  private readonly orgAccessService = inject(OrgAccessService);
  title: string = 'title';
  subTitle: string = 'subtitle';
  parentTitle: string = '';
  pageDescription: string | null = null;
  icon: string = 'home';

  @ViewChild('notificationsMenuTrigger') menuTrigger: MatMenuTrigger;
  @Input() avatarText: string = '';
  @Input() avatar: string | ArrayBuffer;
  @Output() searchEvent: EventEmitter<boolean> = new EventEmitter();
  partialUrlsMatch = partialUrlsMatch;
  showSearchDetail: boolean = false;
  showSearchBar: boolean = false;
  searchResultString = '';
  searchKeyName = '';
  public showNoAccess: boolean = false;
  inspectionId: number;
  searchPlaceHolder: string = 'repair_general_search_msg';
  isInventory: boolean;
  isInventoryHeader: boolean;

  caseId: string = '';
  caseStatus: string = '';
  stepInProgress: boolean = false;
  menuItems: menuItem[] = menuItems;
  tabMenus: menuItem[] = [];

  @Output() toggle = new EventEmitter();
  public menuIcon: string = 'menu-expand';
  public expandedMenu: boolean = true;

  public allTabMenus = [
    {
      name: 'Add customer',
      active: false,
      title: 'add_customer',
      subTitle: 'quote',
      url: '',
      index: 1
    },
    {
      name: 'Add vehicle',
      active: false,
      title: 'add_vehicle',
      url: 'vehicle',
      subTitle: 'quote',
      index: 2
    },
    {
      name: 'Add documents',
      active: false,
      title: 'add_documents',
      subTitle: 'quote',
      url: 'document',
      index: 3
    },
    {
      name: 'Add photos',
      active: false,
      title: 'add_photos',
      subTitle: 'quote',
      url: 'photos',
      index: 4
    },
    {
      name: 'Repair estimate',
      active: false,
      title: 'repair_estimate',
      subTitle: 'quote',
      url: 'estimate',
      index: 5
    }
  ];
  showTabMenus: boolean = false;
  notificationsPerScroll: number = 50;
  skipCounter: number = 0;
  notificationUnreadCount: number = 0;
  notificationList = [];
  notificationGuidList = [];
  notificationTotalCount = 0;
  automotiveServiceId: number = 0;
  domainIds: any[] = [];
  subs: Subscription[] = [];
  hasRepairPermission: boolean;
  hasClaimPermission: boolean;
  hasQuotePermission: boolean;
  hasFnolPermission: boolean;
  hasQuoteAssessmentPermission: boolean;
  hasAutoPermission: boolean;
  hasAccountingPermission: boolean;
  tempUnreadNotificationsCheck: string[] = [];
  ConversationGuid: string;
  customerMobileNumber: string;

  caseDetail: any;
  isExternal: boolean = false;
  public userPermission: any;
  public whatsAppEnabled: boolean = true;
  generalCommunicationMessagesCount: number = 0;
  hasHelpPermission: boolean;
  hasSalesPermission: boolean = false;
  hasProcurementPermission: boolean = false;
  hasSurveyorPermission: boolean;

  @ViewChild('messaging') public messaging: MatSidenav;
  @ViewChild('notificationScrollPanel') notificationScrollPanel: ElementRef<HTMLElement>;
  public notificationLoading = false;
  public notificationLoadingMore = false;
  private notificationHasMore = true;

  @ViewChildren(HasPermissionDirective) permissionDirective;

  public selectedLang: string = 'en';

  config: any = {
    name: 'singleSelect',
    label: '',
    placeHolder: 'select_dot',
    labelKey: 'Name',
    valueKey: 'Code'
  };

  options: Array<any> = [
    { Code: 'ar', Name: 'AR', Direction: 'rtl', Locale: 'ar-AE' },
    { Code: 'en', Name: 'EN', Direction: 'ltr', Locale: 'en' },
    { Code: 'es', Name: 'ES', Direction: 'ltr', Locale: 'es-ES' }
  ];

  public whatsappTotalMessageCount: number = 0;

  /** Show HRMS check-in row when user has HRMS automotive service. */
  showHrmCheckIn = false;
  /** Logged-in user has an open check-in (no checkout yet). */
  isCheckedIn = false;
  /** Logged-in user has at least one attendance check-in for today. */
  hasCheckedInToday = false;
  /** Server-owned button visibility, so a punch is never offered when it would be rejected. */
  canCheckIn = true;
  canCheckOut = false;
  /** Shows AI Studio plan name badge linking to subscriptions. */
  showAiStudioPlanTag = false;
  /** Subscription/plan name shown in the header plan badge. */
  aiStudioPlanTagLabel = '';
  private aiStudioPlanTagSubscription: Subscription | null = null;
  /**
   * The day's effective time so far, INCLUDING the session currently running - not the current
   * session on its own, which under-reported any day with more than one check-in.
   */
  effectiveDisplay = AttendanceService.formatDuration(0);
  /** The day's gross time so far; surfaced as the widget tooltip alongside effective. */
  grossDisplay = AttendanceService.formatDuration(0);
  /** Latest server push; both totals above are re-derived from it on every tick. */
  private hrmCheckInState: HrmCheckInState | null = null;
  private hrmTickTimer: ReturnType<typeof setInterval> | null = null;
  private hrmCheckInReminderTimer: ReturnType<typeof setTimeout> | null = null;
  private hasShownHrmCheckInReminder = false;

  /**
   * constructor
   * @param router
   * @param authService
   * @param commonService
   * @param coreService
   * @param monitorService
   */
  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    public readonly commonService: CommonService,
    private readonly messagesService: MessagesService,
    private readonly monitorService: MonitorService,
    private readonly inspectionService: InspectionService,
    private readonly userService: UserService,
    private readonly attendanceService: AttendanceService,
    private readonly signalR: SignalRService,
    private readonly _snackBar: MatSnackBar,
    private readonly configurationService: ConfigurationService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly translateService: TranslateService,
    public readonly userSelectionService: UserSelectionService,
    private readonly coreService: CoreService,
    private readonly aiService: AiService,
    private readonly aiStudioSubscriptionCtaService: AiStudioSubscriptionCtaService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    this.signalR.hubReceivedMessage.subscribe((data: any) => {
      if (data?.messageType === 'Notification') {
        this.notificationList = [];
        this.notificationGuidList = [];
        this.getNotificationMessages(0);
        this.getNotificationUnreadCount();
      }

      if ([ 'bodyshop manager', 'service advisor' ].includes(this.commonService.roleName) && data?.messageType === 'BidirectionalNotification') {
        const signalRData = JSON.parse(data.message);

        if (signalRData.BidirectionalConversation.IsCustomerResponse && this.router.url.indexOf(signalRData.ObjectGuid) < 0) {
          signalRData.isWhatsApp = true;
          this.showWhatsappToast(10000, signalRData);
          this.getGeneralCommunicationMessagesCount();
        }
      }
        this.changeDetectorRef.markForCheck();
});

    const hubSubscription$ = this.signalR.repairHubReceivedMessage.subscribe((res) => {
      this.handleInAppNotification(res);
    });
    this.subs.push(hubSubscription$);

    this.subs.push(
      this.commonService.userProfileData.subscribe({
        next: (data) => {
          if (data) {
            data.data.userPermission?.automotiveServices.forEach((item) => {
              if (
                item.automotiveServiceName === 'Addenda Repair' ||
                item.automotiveServiceName === 'Carheal Quote' ||
                item.automotiveServiceName === 'Addenda Claims' ||
                item.automotiveServiceName === 'Quote Assessment' ||
                item.automotiveServiceName === 'Addenda Inventory' ||
                item.automotiveServiceName === 'Service Management' ||
                item.automotiveServiceName === 'Claim Surveyor' ||
                item.automotiveServiceName === 'Accounting'
              ) {
                this.automotiveServiceId = item.automotiveServiceId;
                this.domainIds.push(item.domainId);
              }
            });

            const permissionRepair = data?.data.userPermission?.automotiveServices?.find((x) => {
              return x.automotiveServiceName === 'Addenda Repair';
            });

            if (permissionRepair) {
              this.coreService.getHelpResources(undefined, permissionRepair.autoMotiveServiceID, true).subscribe({
                next: (val) => {
                  if (val['@odata.count'] > 0) {
                    this.hasHelpPermission = true;
                  }
                                this.changeDetectorRef.markForCheck();
}
              });
            }

            const automotiveServices = data.data?.userPermission?.automotiveServices;
            const permissionList = automotiveServices?.find(x => x.automotiveServiceName.toLowerCase() === 'carheal quote')?.permissions;
            const quoteMenus = this.menuItems?.find(x => x.name === 'quote')?.childMenu;
            if (quoteMenus && quoteMenus?.length > 0 && permissionList && permissionList?.length > 0) {
              this.isExternal = this.commonService.hasPermission('case.external', permissionList);
            }

            const { userPermission } = data.data;

            const automotiveService = automotiveServices?.find(x => x.automotiveServiceName.toLowerCase() === 'addenda repair');
            const automotiveServiceInventory = automotiveServices?.find(x => x.automotiveServiceName.toLowerCase() === 'addenda inventory');
            this.commonService.roleName = automotiveService?.roleName?.toLowerCase();

            this.userPermission = userPermission;
            this.showHrmCheckIn = this.orgAccessService.hasAllOrgAutomotiveServices([ 'hrms', 'addenda repair' ]);
            if (this.showHrmCheckIn) {
              this.subscribeHrmCheckInState();
              this.fetchHrmCurrentCheckIn();
              this.syncHrmClockInReminder();
            } else {
              this.isCheckedIn = false;
              this.hasCheckedInToday = false;
              this.stopHrmClockInReminder();
              this.resetHrmTotals();
            }
            this.commonService.setPermission(automotiveServices);
            this.hasRepairPermission = this.commonService.repairPermission;
            this.hasClaimPermission = this.commonService.claimPermission;
            this.hasQuotePermission = this.commonService.quotePermission;
            this.hasFnolPermission = this.commonService.fnolPermission;
            this.hasQuoteAssessmentPermission = this.commonService.quoteAssessmentPermission;
            this.hasAutoPermission = this.commonService.autoAdminPermission;
            this.hasAccountingPermission = this.commonService.accountingPermission;
            this.hasSalesPermission =
              this.commonService.hasSalesPermission() &&
              !!automotiveServiceInventory &&
              (automotiveServiceInventory.roleName?.toLowerCase() === 'supplier' ||
                automotiveServiceInventory.roleName?.toLowerCase() === 'inventory manager');
            this.hasProcurementPermission =
              this.commonService.hasPartsProcurementPermission() &&
              !!automotiveServiceInventory &&
              (automotiveServiceInventory.roleName?.toLowerCase() === 'buyer' ||
                automotiveServiceInventory.roleName?.toLowerCase() === 'inventory manager');
            this.hasSurveyorPermission = this.commonService.surveyorPermission;
            if (!this.hasRepairPermission) {
              if (
                automotiveServiceInventory &&
                this.commonService.hasSalesPermission() &&
                automotiveServiceInventory.roleName?.toLowerCase() === 'supplier'
              ) {
                if (!location.href.includes('inventory/sales') && sessionStorage.getItem('navigatedToDashboard') !== 'true') {
                  sessionStorage.setItem('navigatedToDashboard', 'true');
                  this.router.navigate([ 'inventory/sales/supplier-dashboard' ]);
                }
              }

              if (
                automotiveServiceInventory &&
                this.commonService.hasPartsProcurementPermission() &&
                automotiveServiceInventory.roleName?.toLowerCase() === 'buyer'
              ) {
                if (!location.href.includes('inventory/sales') && sessionStorage.getItem('navigatedToDashboard') !== 'true') {
                  sessionStorage.setItem('navigatedToDashboard', 'true');
                  this.router.navigate([ 'inventory/procurement/dashboard' ]);
                }
              }
            }

            let isRepairerView = false;
            if (this.router.url.indexOf('/repairer-view/') > -1) {
              isRepairerView = true;
            }

            if (this.hasRepairPermission || isRepairerView) {
              this.searchPlaceHolder = 'repair_general_search_msg';
            }

            if (this.hasClaimPermission && !isRepairerView) {
              this.searchPlaceHolder = 'claim_general_search_msg';
            }

            const packages = data?.data?.userPermission?.orgPackages;
            const channels = packages?.find(x => x.description === 'WhatsApp Bidirectional');
            if (channels) {
              const whatsappPermission = channels.permissions.find(x => x.permissionName === 'whatsapp.bidirectional');
              if (whatsappPermission) {
                this.whatsAppEnabled = true;
              } else {
                this.whatsAppEnabled = false;
              }
            } else {
              this.whatsAppEnabled = false;
            }

            this.refreshAiStudioPlanTag(data.data);
          }
                this.changeDetectorRef.markForCheck();
}
      })
    );

    this.commonService.accessRight.subscribe({
      next: (res: boolean) => {
        if (!res) {
          this.showNoAccess = true;
        }
            this.changeDetectorRef.markForCheck();
}
    });

    this.commonService.closeSearch.subscribe({
      next: (closeSearch: boolean) => {
        if (closeSearch) {
          this.close();
        }
      }
    });

    this.commonService.inProgressSteps.subscribe((length: number) => {
      this.stepInProgress = length > 0;
        this.changeDetectorRef.markForCheck();
});

    this.commonService.caseId.subscribe((id) => {
      if (id) {
        this.caseId = id;
      }
        this.changeDetectorRef.markForCheck();
});

    this.commonService.inspectionId.subscribe((inspectionId) => {
      if (inspectionId) {
        this.inspectionId = inspectionId;
      }
        this.changeDetectorRef.markForCheck();
});

    this.commonService.caseStatus.subscribe((caseStatus) => {
      if (caseStatus) {
        this.monitorService.logEvent('caseStatus', [
          'HeaderComponent',
          'addenda-quote',
          {
            caseStatus
          }
        ]);
        this.caseStatus = caseStatus;
      }
        this.changeDetectorRef.markForCheck();
});

    this.subs.push(
      this.commonService.pageChange$.subscribe((menuRoutes: string[]) => {
        if (this.showTabMenus && menuRoutes[1]) {
          const subMenuItem = this.tabMenus?.find(x => x.url === menuRoutes[1]);
          if (subMenuItem) {
            subMenuItem.active = true;
            this.title = subMenuItem.title;
            this.subTitle = subMenuItem.subTitle;
            return;
          }
        } else if (this.tabMenus[0]) {
          this.tabMenus[0].active = true;
        }
            this.changeDetectorRef.markForCheck();
})
    );

    this.router?.events?.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: any) => {
      const caseId = this.route?.firstChild.snapshot.params['id'];
      this.monitorService.logEvent('router.navigationStart', [
        'HeaderComponent',
        'addenda-quote',
        {
          event
        }
      ]);

      if (event.navigationTrigger === 'popstate' && event.url === 'quote/case/0' && caseId) {
        this.router.navigate([ `quote/case/${caseId}` ], { queryParams: { isBack: true }, replaceUrl: true });
      }

      const url = event.url == '/' ? '/home' : event.url;

      if (url.indexOf('/quote/case/') != -1) {
        this.showTabMenus = true;
      } else {
        this.showTabMenus = false;
      }

      if (
        event.url.includes('/customer-management') &&
        !(this.router.url.includes('/customer-management') || this.router.url.includes('/repair/booking/'))
      ) {
        localStorage.removeItem('customerFilter');
      }
        this.changeDetectorRef.markForCheck();
});

    this.router.events?.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      window.scrollTo(0, 0);
      const url = event.url == '/' ? '/home' : event.url;
      if (event.url.includes('/inventory')) {
        this.isInventory = true;
        this.isInventoryHeader = false;
        const detailUrls = [ 'offer-requested-detail', 'offer-sent-detail', 'order-requested-detail', 'order-sent-detail', 'order-return-detail' ];
        detailUrls.forEach((x) => {
          if (event.url.includes(x)) {
            this.isInventoryHeader = true;
          }
        });
      }

      if (url === '/accessDenied') {
        this.title = 'access_denied';
        this.subTitle = null;
        this.icon = null;
        return;
      } else if (url === '/notFound') {
        this.title = 'not_found';
        this.subTitle = null;
        this.icon = null;
        return;
      } else if (url === '/profile') {
        this.title = 'my_profile';
        this.subTitle = 'home';
        this.icon = 'home';

        sessionStorage.setItem('pagenumber', '1');
        ChqCasesTableComponent.currentPage = 1;
        ChqCasesTableComponent.filterDetail = [];
        return;
      } else if (url.includes('/fnol')) {
        const partialUrlMatchData = this.partialUrlsMatch.filter(item => url.indexOf(item.partialUrl) != -1);
        if (partialUrlMatchData.length > 0 && partialUrlMatchData[0].title) {
          this.title = partialUrlMatchData[0].title;
          this.subTitle = partialUrlMatchData[0].subTitle;
          this.icon = partialUrlMatchData[0].icon;
          this.commonService.updatePage(this.title, this.subTitle);
          return;
        }
        return;
      } else if (url.includes('/case/detail/') || url.includes('help-section')) {
        return;
      } else if (url === '/repair/check-in-out-logs') {
        this.title = this.translateService.instant('check_in_check_out_logs');
        this.subTitle = this.translateService.instant('repair');
        this.icon = null;
        return;
      } else if (url === '/settings/partners/add-supplier') {
        this.title = 'partners';
        this.subTitle = 'settings';
        this.icon = null;
        return;
      } else if (this.shouldSkipHeaderUpdate(url)) {
        return;
      } else {
        this.getTitleFromMenuItems(url, event);
      }
        this.changeDetectorRef.markForCheck();
});

    this.hasRepairPermission = this.commonService.repairPermission;
    this.hasClaimPermission = this.commonService.claimPermission;
    this.hasQuotePermission = this.commonService.quotePermission;
    this.hasFnolPermission = this.commonService.fnolPermission;
    this.hasSurveyorPermission = this.commonService.surveyorPermission;

    let isRepairerView = false;
    if (this.router.url?.indexOf('/repairer-view/') > -1) {
      isRepairerView = true;
    }

    if (this.hasRepairPermission || isRepairerView) {
      this.searchPlaceHolder = 'repair_general_search_msg';
    }

    if (this.hasClaimPermission && !isRepairerView) {
      this.searchPlaceHolder = 'claim_general_search_msg';
    }

    const caseDetail = this.commonService.caseDetail.subscribe((caseDetail) => {
      this.caseDetail = caseDetail;
        this.changeDetectorRef.markForCheck();
});

    this.subs.push(caseDetail);

    const openGeneralChat$ = this.commonService.generalCommOpen$.subscribe((event: string) => {
      if (event === 'open') {
        this.openChatWindow();
      }
    });

    this.subs.push(openGeneralChat$);

    const tabChangeEvent = this.commonService.tabChange$.subscribe((tab: menuItem) => {
      if (tab) {
        this.title = tab.title;
        this.subTitle = tab.subTitle;
      }
        this.changeDetectorRef.markForCheck();
});

    this.subs.push(tabChangeEvent);

    this.breakpointObserver.observe([ '(max-width: 576px)' ]).subscribe((result: BreakpointState) => {
      if (result.matches) {
        this.expandedMenu = false;
        this.menuIcon = 'menu-collapse';
      } else {
        this.expandedMenu = true;
        this.menuIcon = 'menu-expand';
      }
        this.changeDetectorRef.markForCheck();
});

    const settings = localStorage.getItem('languageSettings');
    if (settings !== null && settings !== undefined && settings !== 'undefined') {
      const languageSettings = JSON.parse(settings);
      this.selectedLang = languageSettings.selectedLanguage;
      this.commonService.loadLocaleMessages(this.selectedLang);
    }

    this.userSelectionService.switchOrg$.subscribe(() => {
      this.switchOrganization();
    });
  }

  /**
   * get current case status
   */
  get caseStatusIndex(): number {
    return caseIndexMapper[this.caseStatus?.toLowerCase()];
  }

  /**
   * close search bar
   */
  close(): void {
    this.showSearchBar = false;
    this.searchEvent.emit(false);
    this.showSearchDetail = false;
  }

  /**
   * open chat window
   */
  async openChatWindow(ConversationGuid?: string, customerMobileNumber?: string): Promise<void> {
    // The count only decides whether to show the sales prompt for orgs without the package,
    // so it is not worth a request when WhatsApp is already enabled.
    if (!this.whatsAppEnabled) {
      await this.getWhatsappMessageCount();

      if (this.whatsappTotalMessageCount <= 0) {
        this.commonService.openAlertDialog('information', 'contact_addenda_sales');
        return;
      }
    }
    this.ConversationGuid = ConversationGuid ?? null;
    this.customerMobileNumber = customerMobileNumber ?? null;
    this.messaging.toggle();
  }

  /**
   * get whatsapp message count
   */
  async getWhatsappMessageCount(): Promise<void> {
    const queryParams = '?$count=true&$top=0';
    this.commonService.showLoading();
    return await firstValueFrom(this.messagesService.getGeneralCommunicationMessages(queryParams))
      .then((resp) => {
        if (resp) {
          this.whatsappTotalMessageCount = resp['@odata.count'];
        }
        this.commonService.hideLoading();
      })
      .catch((err) => {
        console.log(err);
        this.commonService.hideLoading();
      });
  }

  /**
   * load more
   */
  loadMorePages($event): void {
    this.searchResultString = $event.searchKey;
    this.searchKeyName = $event.searchKeyName;
    this.showSearchBar = false;
    this.searchEvent.emit(true);
    this.showSearchDetail = true;
  }

  /**
   * open user profile
   */
  openProfile(): void {
    this.monitorService.logEvent('openProfile', [ 'HeaderComponent', 'addenda-quote' ]);
    this.router.navigate([ 'profile' ]);
  }

  /**
   * logout
   */
  logout(): void {
    this.monitorService.logEvent('logout', [ 'HeaderComponent', 'addenda-quote' ]);
    const dialogRef = this.commonService.openConfirmationOkDialog(
      this.translateService.instant('logout'),
      this.translateService.instant('want_logout')
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const localData = localStorage.getItem('cid');
        if (localData && localData !== 'null' && localData.toUpperCase() === 'TATA') {
          this.commonService.getAccessToken().subscribe((res) => {
            const token = this.parseJwt(res);
            window.location.href = `${environment.keyCloakLogoutUrl + environment.baseUrl}/logoutext` + `&id_token_hint=${token.extid}`;
          });
        } else if (localData && localData !== 'null' && localData.toUpperCase() === 'EVTATA') {
          this.commonService.getAccessToken().subscribe((res) => {
            const token = this.parseJwt(res);
            window.location.href = `${environment.keyCloakEVLogoutUrl + environment.baseUrl}/logoutext` + `&id_token_hint=${token.extid}`;
          });
        } else {
          this.authService.signOut();
        }
      }
    });
  }

  /**
   * decode access token
   * @returns promise
   */
  parseJwt(token): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  /**
   * check is going to previous Route
   */
  isPrevious(target: menuItem, current: menuItem): boolean {
    const targetIndex = this.tabMenus.indexOf(target);
    const currentIndex = this.tabMenus.indexOf(current);
    if (targetIndex < currentIndex) {
      return true;
    }
    return false;
  }

  /**
   * map inspection from api
   * @param inspectionData
   */
  mapInspection(inspectionData: any, item: menuItem, previousActive: menuItem[], minBulkCount: number): void {
    if (inspectionData) {
      try {
        const inspection = inspectionData;
        const bulkUploadedItemsWithImages = inspection.inspectionItems.filter((step) => {
          return step.rawAzureBlobUrl != null && step.rawAzureBlobUrl != '';
        });
        const requiredStepWOImage = inspection.inspectionItems.find((x: any) => Object.hasOwn(x, 'isSkipEnabled') && !x.isSkipEnabled && x.url == '');

        if (bulkUploadedItemsWithImages.length < minBulkCount && inspection.uploadType === 'Bulk') {
          const numberToDisplay = minBulkCount;
          this.commonService.showToast(0, `All ${numberToDisplay} sides images are mandatory and cannot skip to next section.`);
          return;
        } else if (requiredStepWOImage) {
          const numberToDisplay = inspection.inspectionItems.filter(
            (x: any) => Object.hasOwn(x, 'isSkipEnabled') && !x.isSkipEnabled && x.url == ''
          ).length;
          this.commonService.showToast(0, `All ${numberToDisplay} sides images are mandatory and cannot skip to next section.`);
          return;
        } else {
          let isGoingPrevious = false;
          if (previousActive?.length > 0) {
            isGoingPrevious = this.isPrevious(item, previousActive[0]);
          }
          const extraParam = {};
          if (item?.url === 'estimate') {
            extraParam['skipUpdate'] = true;
          }
          this.tabMenus.map(x => (x.active = false));
          if (item) {
            item.active = true;
          }
          this.router.navigate([ `quote/case/${this.caseId}${item?.url ? `/${item?.url}` : ''}` ], {
            queryParams: { ...extraParam, isBack: isGoingPrevious }
          });
          this.commonService.titleConfig$.next({
            title: item?.title,
            subTitle: item?.subTitle
          });
        }
      } catch (error: any) {
        console.log(error);
      }
    }
  }

  /**
   * handle supplier notification navigation url
   */
  handleInAppNotification(data: any): void {
    const isInAppNotification =
      [
        'SupplierOrderConfirmed',
        'SupplierReturnApprovedRejected',
        'OfferRequestExpired',
        'OfferRequested',
        'SupplierReturnRequested',
        'RepairerLaunchOrder',
        'ClaimWorkOrderReceived',
        'RepairerCancelOrder'
      ].indexOf(data?.type) !== -1;
    if (isInAppNotification) {
      data.Data = { ObjectGuid: data?.objectGuid, ObjectType: data?.objectType };
      const navUrl = this.getNavigationUrl(data?.type, data);
      if (!navUrl) {
        return;
      }
      this.commonService.showBarNotification({
        title: data.title,
        Message: data?.message,
        SendOn: data?.eventDate,
        showButton: true,
        notificationLink: navUrl,
        isSupplierNotification: true,
        showDate: true
      });
    }
  }

  /**
   * get current inspectionItems length
   */
  getInspectionItems(id, item: menuItem, previousItem: menuItem[]): void {
    this.commonService.showLoading();
    this.inspectionService.getInspectionTemplateList(2100).subscribe({
      next: (inspectionList: any) => {
        let inspectionTemplateId = 0;
        const repairInspectionTemplate = inspectionList?.data;

        if (repairInspectionTemplate.length > 0) {
          this.commonService.repairInspectionTemplate = repairInspectionTemplate[0];
          inspectionTemplateId = repairInspectionTemplate[0].id;
        }
        const serverDetails = forkJoin({
          inspectionTemplate: this.inspectionService.getInspectionTemplate(inspectionTemplateId),
          inspectionDetail: this.inspectionService.getInspection(id)
        }).pipe(catchError(error => of(error)));
        serverDetails.subscribe({
          next: (mapResponse: any) => {
            if (mapResponse) {
              if (mapResponse.inspectionDetail) {
                const minCount = mapResponse.inspectionTemplate.minImageLimit;
                this.mapInspection(mapResponse.inspectionDetail, item, previousItem, minCount);
              }
            }

            this.commonService.hideLoading();
          },
          complete: () => {
            this.commonService.hideLoading();
          }
        });
      }
    });
  }

  /**
   * tab change event
   * @param item
   */
  tabChanged(item: menuItem): void {
    this.monitorService.logEvent('tabChanged', [
      'HeaderComponent',
      'addenda-quote',
      {
        item
      }
    ]);

    if (this.showNoAccess) {
      return;
    }

    if (this.caseId && this.caseId !== '0') {
      if ((!this.caseDetail?.registrationDate || !this.caseDetail?.modelYearRange) && item.index > 2 && this.isExternal) {
        return;
      }

      if (this.caseDetail?.status?.toLowerCase() === 'vehicledetails' && item.index > 3) {
        return;
      }

      const previousActive = this.tabMenus.filter(x => x.active);
      if (previousActive && previousActive[0].name === item.name) {
        return;
      }
      let isGoingPrevious = false;

      if (previousActive[0].index === 4 || previousActive[0].index === 3) {
        if (this.stepInProgress) {
          const module = previousActive[0].index === 4 ? 'images' : 'documents';
          this.commonService.showToast(0, `Please wait until all ${module} are uploaded.`);
          return;
        }
      }

      const currentIndex = caseIndexMapper[this.caseStatus?.toLowerCase()];
      if (item.index === 5 && currentIndex >= 5) {
        const isImagesAvailable = this.tabMenus.filter((t) => {
          return t.name === 'photos';
        });
        if (isImagesAvailable.length > 0) {
          this.getInspectionItems(this.inspectionId, item, previousActive);
          return;
        }
      }

      if (item.index && currentIndex == 1 && currentIndex + 1 < item.index) {
        return;
      }

      if (previousActive.length > 0) {
        isGoingPrevious = this.isPrevious(item, previousActive[0]);
      }
      const extraParam = {};
      if (item.url === 'estimate') {
        extraParam['skipUpdate'] = true;
      }
      this.tabMenus.map(x => (x.active = false));
      item.active = true;
      this.router.navigate([ `quote/case/${this.caseId}${item.url ? `/${item.url}` : ''}` ], {
        queryParams: { ...extraParam, isBack: isGoingPrevious }
      });
    }
  }

  /**
   * checkAgoFormat
   * @param {*} dateTime
   * @returns {string}
   */
  checkAgoFormat(date): string {
    if (date.indexOf('Z') === -1) {
      date += 'Z';
    }
    if (dayjs(date).isToday()) {
      return dayjs().to(dayjs(date));
    } else {
      return dayjs(date).format('MMM DD, YYYY - hh:mm A');
    }
  }

  /**
   * notificationMessageGenerate
   * @param {*} item
   */
  getNotificationMessages(skip): void {
    this.skipCounter = skip;
    if (skip === 0) {
      this.notificationHasMore = true;
      if (this.notificationList.length === 0) {
        this.notificationLoading = true;
      }
    }
    this.userService.getNotifications(this.notificationsPerScroll, skip, 'CreatedDate desc', this.domainIds).subscribe({
      next: (data: any[]) => {
        if (data && data['@odata.count'] > 0) {
          this.notificationTotalCount = data['@odata.count'];
          if (this.notificationTotalCount === 0 && this.skipCounter !== 0) {
            this.skipCounter -= this.notificationsPerScroll;
          }
          if (this.notificationTotalCount !== 0) {
            const dataRemovedDuplicates = data['value']
              ?.filter(notification => this.notificationGuidList.indexOf(notification.NotificationGuid) == -1)
              .map((item) => {
                return { ...item, isShowActionButton: this.isShowActionButton(item), actionButtonText: this.actionButtonText(item) };
              });
            this.notificationList = [ ...this.notificationList, ...dataRemovedDuplicates ];
            this.notificationGuidList = [ ...this.notificationGuidList, ...dataRemovedDuplicates.map(notification => notification.NotificationGuid) ];
            this.notificationHasMore =
              this.skipCounter + this.notificationsPerScroll < this.notificationTotalCount;
            this.maybeLoadMoreNotificationsIfShort();
          }
        }
            this.changeDetectorRef.markForCheck();
},
      complete: () => {
        this.notificationLoading = false;
        this.notificationLoadingMore = false;
            this.changeDetectorRef.markForCheck();
},
      error: () => {
        this.notificationLoading = false;
        this.notificationLoadingMore = false;
            this.changeDetectorRef.markForCheck();
},
    });
  }

  /**
   * Get total Unread notification count
   * @param {*} notification
   */
  getNotificationUnreadCount(): void {
    this.userService.getNotificationsUnreadCount(this.domainIds).subscribe((count: any) => {
      this.notificationUnreadCount = count;
        this.changeDetectorRef.markForCheck();
});
  }

  /**
   * setNotificationRead
   * @param {*} notification
   */
  setNotificationRead(notification): void {
    if (notification.IsRead) {
      return;
    }
    if (this.tempUnreadNotificationsCheck.includes(notification.NotificationGuid)) {
      return;
    }
    this.tempUnreadNotificationsCheck.push(notification.NotificationGuid);
    this.userService.markAsReadNotification(notification.NotificationGuid).subscribe({
      next: (data) => {
        if (data.success) {
          this.notificationList = this.notificationList.map(item => (item.Id === notification.Id ? { ...item, IsRead: true } : item));
          this.getNotificationUnreadCount();
        } else {
          this.commonService.showToast(0, 'Could Not Mark It as Unread. Please Try again later');
        }
            this.changeDetectorRef.markForCheck();
}
    });
  }

  /**
   * setAllNotificationsRead
   * @date 7/10/2023 - 3:46:35 PM
   */
  setAllNotificationsRead(): void {
    if (this.notificationUnreadCount <= 0) {
      return;
    }
    this.commonService.showLoading();
    forkJoin(this.domainIds.map(domainId => this.userService.markAllAsReadNotification(domainId))).subscribe({
      next: (res) => {
        let failed = false;
        res.forEach((data) => {
          if (!data['success']) {
            failed = true;
          }
        });
        this.commonService.hideLoading();
        if (!failed) {
          this.notificationList = this.notificationList.map((item) => {
            return { ...item, IsRead: true };
          });
          this.notificationUnreadCount = 0;
        } else {
          this.commonService.showToast(0, 'Could Not Mark Notifications as Unread. Please Try again later');
        }
            this.changeDetectorRef.markForCheck();
}
    });
  }

  /**
   * handle in app notification navigation url
   */
  getNavigationUrl(type: string, item: any): string {
    if (type === 'OfferRequested') {
      if (this.hasProcurementPermission) {
        return `/inventory/procurement/offers/${item.Data?.ObjectGuid}`;
      } else {
        if (item.Data?.ObjectType === 'Buyer') {
          return '';
        }
        return `/inventory/sales/offer-requested-detail/${item.Data?.ObjectGuid}`;
      }
    } else if (type === 'OfferRequestExpired') {
      if (this.hasProcurementPermission) {
        return `/inventory/procurement/offers/${item.Data?.ObjectGuid}`;
      } else {
        return `/repair/booking/${item.Data?.ObjectGuid}/parts`;
      }
    } else if (type === 'SupplierOrderConfirmed') {
      if (this.hasProcurementPermission) {
        return `/inventory/procurement/orders/${item.Data?.ObjectGuid}`;
      } else {
        return `/repair/booking/${item.Data?.ObjectGuid}/parts`;
      }
    } else if (type === 'RepairerLaunchOrder' || type === 'RepairerCancelOrder') {
      if (this.hasSalesPermission) {
        return `/inventory/sales/order-requested-detail/${item.Data?.ObjectGuid}`;
      } else if (this.hasProcurementPermission) {
        return `/inventory/procurement/orders/${item.Data?.ObjectGuid}`;
      } else {
        return `/repair/booking/${item.Data?.ObjectGuid}/parts`;
      }
    } else if (type === 'SupplierReturnRequested') {
      return `/inventory/sales/order-return-detail/${item.Data?.ObjectGuid}`;
    } else if (type === 'SupplierReturnApprovedRejected') {
      if (item.Data?.ObjectType === 'Buyer') {
        return `/inventory/procurement/returns/${item.Data?.ObjectGuid}`;
      }
      return `/repair/booking/${item.Data?.ObjectGuid}/parts`;
    } else if (type === 'ClaimWorkOrderReceived') {
      return `/repair/booking/${item?.repairGuid}/estimate`;
    }
    return '';
  }

  /**
   * notificationNavigate
   * @param {*} event
   * @param {*} repairId
   * @param {*} type
   */
  notificationNavigate(event, id, type, item): void {
    this.menuTrigger?.closeMenu();
    if (type === 'ViewParts') {
      if (this.hasProcurementPermission) {
        this.router.navigate([ `/inventory/procurement/offers/${item.Data?.ObjectGuid}` ]);
        return;
      }
      this.router.navigate([ `/repair/booking/${id}/parts` ], { queryParams: { mode: 'edit' } });
      this.commonService.activeItem.next('Repair');
    } else if (type === 'ViewRepairHistory') {
      this.router.navigate([ `/repair/booking/${id}/estimate` ], { queryParams: { mode: 'edit', history: 'open' } });
    } else if (type === 'SendIntimationInformation') {
      this.router.navigate([ `/claim/fnol-details/${item.Data?.ClaimGuid}` ]);
    } else if (type === 'ClaimSubmitForReview') {
      if (item?.Type == 'EstimateReceived') {
        this.router.navigate(
          [ `/claim/claim-detail-v2/${encodeURIComponent(item.Data?.PoliceReferenceNo)}/${encodeURIComponent(item.Data?.IntimationNo)}/details` ],
          { queryParams: { from: 'notification', selectedTab: `${item.Data?.ClaimGuid},garage` } }
        );
      } else {
        this.router.navigate(
          [ `/claim/claim-detail-v2/${encodeURIComponent(item.Data?.PoliceReferenceNo)}/${encodeURIComponent(item.Data?.IntimationNo)}/details` ],
          { queryParams: { selectedTab: `${item.Data?.ClaimGuid},garage` } }
        );
      }
    } else if (type === 'CaseSubmitForReview') {
      this.router.navigate([ `/case/detail/${item.Data?.CaseGuid}` ], { queryParams: { selectedIndex: '0' } });
    } else if (type === 'GarageReAssignment') {
      this.router.navigate(
        [ `/claim/claim-detail-v2/${encodeURIComponent(item.Data?.PoliceReferenceNo)}/${encodeURIComponent(item.Data?.IntimationNo)}/details` ],
        { queryParams: { selectedTab: `${item.Data?.ClaimGuid},garage` } }
      );
    } else if (type === 'GarageEstimateNotification') {
      if (item.Data?.ClaimGuid) {
        this.router.navigate(
          [ `/claim/claim-detail-v2/${encodeURIComponent(item.Data?.PoliceReferenceNo)}/${encodeURIComponent(item.Data?.IntimationNo)}/details` ],
          { queryParams: { from: 'notification', selectedTab: `${item.Data?.ClaimGuid},garage` } }
        );
      } else if (item.Data?.RepairGuid) {
        this.router.navigate([ `/repairer-view/booking/${item.Data?.RepairGuid}/estimate` ], { queryParams: { repairView: 'true' } });
      }
    } else if (type === 'SendRequestForRepairInvoice' || item.Type === 'SendRequestForRepairInvoice') {
      this.router.navigate([ `/repair/booking/${id}/invoices` ]);
    } else if (
      type === 'IntimationRequestRejected' ||
      item.Type === 'SendRequestForRepairEstimate' ||
      item.Type === 'ClaimRejected' ||
      item.Type === 'RepairClaimIntimationApproved' ||
      item.Type === 'RepairClaimIntimationRejected'
    ) {
      this.router.navigate([ `/repair/booking/${id}/` ]);
    } else if (
      [ 'ApprovalRequestResponseFromClaim', 'EstimateRevisionFromClaim', 'ClaimWorkOrderReceived', 'EstimateInternalApproval' ].indexOf(item.Type) !==
      -1
    ) {
      this.router.navigate([ `/repair/booking/${id}/estimate` ], { queryParams: { mode: 'edit' } });
    } else if (item.Data?.Action?.indexOf('ClaimRequest') !== -1) {
      this.notificationViewClaimRequest(item, item.Message, item.Data?.ObjectGuid);
    } else if (item.Data?.Action.indexOf('IntimationRequest') !== -1) {
      this.notificationViewIntimationRequest(item, item.Message, item.Data?.ObjectGuid);
    } else if (item.Type === 'BidirectionalMessage') {
      if (item.Data?.ObjectGuid) {
        if (this.hasClaimPermission) {
          this.router.navigate(
            [ `/claim/claim-detail-v2/${encodeURIComponent(item.Data?.PoliceReferenceNo)}/${encodeURIComponent(item.Data?.IntimationNo)}/details` ],
            { queryParams: { conversationGuid: item.Data?.ConversationGuid } }
          );
        } else {
          this.router.navigate([ `/repair/booking/${item.Data?.ObjectGuid}` ], { queryParams: { conversationGuid: item.Data?.ConversationGuid } });
        }
      } else {
        this.openChatWindow(item.Data?.ConversationGuid, item.Data?.CustomerMobileNumber);
      }
    } else if (item.Type === 'BookingDelayed' || item.Type === 'BookingOutDelayed' || item.Type === 'BookingInDelayed') {
      this.router.navigate([ `/repair/technician-calendar/${item.Data?.RepairGuid}` ]);
    } else if (item.Type === 'ReorderLevel') {
      this.router.navigate([ `/inventory/detail/${item.Data?.InventoryItemGuid}` ]);
    } else if (this.hasRepairPermission && item.Type?.toLowerCase() == 'bookingassigned') {
      this.router.navigate([ `/repair/technician-calendar/${item.Data?.RepairGuid}` ]);
    } else if (item.Type?.toLowerCase() == 'bookingassigned' || item.Type?.toLowerCase() == 'repaircreated') {
      this.router.navigate([ `/booking-management/customer-detail/${item.Data?.ObjectGuid}` ], { queryParams: { selectedIndex: 0 } });
    } else if (type === 'ViewRepair') {
      // TODO: This condition should be always at the end.
      this.router.navigate([ `/repair/booking/${id}/` ]);
    } else if (item.Type === 'CreditNoteApproval') {
      this.router.navigate([ `/accounting/receivable/credit-notes/${item.Data?.ObjectGuid}` ]);
      return;
    } else if (item.Type === 'DebitNoteApproval') {
      this.router.navigate([ `/accounting/payable/debit-notes/${item.Data?.ObjectGuid}` ]);
      return;
    } else {
      const getSupplierUrl = this.getNavigationUrl(item.Type, item);
      if (getSupplierUrl && getSupplierUrl !== '') {
        this.router.navigate([ getSupplierUrl ]);
      }
    }
  }

  /**
   * notificationViewClaimRequest
   */
  notificationViewClaimRequest(item, message, bookingGuid): void {
    this.menuTrigger?.closeMenu();
    this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
      this.router.navigate([ '/repair/requests' ], { queryParams: { requestId: bookingGuid } });
    });
  }

  /**
   * notificationViewIntimationRequest
   */
  notificationViewIntimationRequest(item, message, bookingGuid): void {
    this.menuTrigger.closeMenu();
    const messageJSON = JSON.parse(message);
    this.dialog.open(RepairIntimationRequestComponent, {
      data: { ...messageJSON, bookingGuid, type: item.Data.Action, notificationGuid: item.NotificationGuid },
      maxHeight: '90vh',
      minHeight: '400px',
      minWidth: '400px',
      disableClose: true
    });
  }

  /**
   * stopEventPropagation
   * @param {*} event
   */
  stopEventPropagation(event): void {
    event.stopPropagation();
  }

  /**
   * Finds a menu item by URL across nested child menus.
   */
  private findMenuItemByUrl(url: string, menus: menuItem[], rootItem?: menuItem): { matchedItem: menuItem; rootItem: menuItem } | null {
    for (const currentMenu of menus || []) {
      const topMenu = rootItem ?? currentMenu;
      if (currentMenu.url === url) {
        return { matchedItem: currentMenu, rootItem: topMenu };
      }

      if (currentMenu.childMenu?.length) {
        const nestedMatch = this.findMenuItemByUrl(url, currentMenu.childMenu, topMenu);
        if (nestedMatch) {
          return nestedMatch;
        }
      }
    }

    return null;
  }

  /**
   * Sets title, subtitle, and icon from matched menu data.
   */
  private setPageFromMenu(matchedItem: menuItem, rootItem: menuItem): void {
    this.title = matchedItem.title;
    this.subTitle = matchedItem.subTitle;
    this.pageDescription = matchedItem.pageDescription ?? rootItem.pageDescription ?? null;
    this.icon = rootItem.icon ?? matchedItem.icon ?? 'home';
  }

  /**
   * Skip header refresh for child/detail screens that keep parent header state.
   */
  private shouldSkipHeaderUpdate(url: string): boolean {
    const skipHeaderRoutes = [
      '/customer-management?selectedIndex',
      '/customer-management/customer-detail/',
      '/catalog-management?selectedIndex',
      '/booking-management/customer-detail/',
      '/content-management/banner?selectedIndex',
      '/content-management/content?selectedIndex',
      '/content-management/look-feel?selectedIndex'
    ];

    return skipHeaderRoutes.some(route => url.includes(route));
  }

  /**
   * ng onInit
   */
  ngOnInit(): void {
    if (this.hasQuotePermission) {
      const stepData = this.configurationService.getStepByDomainId(2100);

      const orderedStepMenu = [];

      stepData
        .sort((a, b) => a.SortOrder - b.SortOrder)
        .forEach((element) => {
          const menuItem = this.allTabMenus.find(x => x.name == QUOTE_MENU[element.ItemKey]);
          if (menuItem) {
            menuItem.title = element?.ItemValue ?? menuItem.title;
            orderedStepMenu.push(menuItem);
          }
        });

      this.tabMenus = orderedStepMenu;
    }

    this.getNotificationUnreadCount();
    this.getGeneralCommunicationMessagesCount();
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    if (this.notificationList.length === 0) {
      this.getNotificationMessages(0);
    }
  }

  /**
   * notificationMenuOpened
   */
  notificationReachBottom(): void {
    if (this.notificationLoadingMore || !this.notificationHasMore) {
      return;
    }
    this.notificationLoadingMore = true;
    this.skipCounter += this.notificationsPerScroll;
    this.getNotificationMessages(this.skipCounter);
  }

  /**
   * Loads the next notification page when the panel is scrolled near the bottom.
   * @param event Scroll event from the notification panel.
   */
  onNotificationPanelScroll(event: Event): void {
    const el = event.target as HTMLElement;
    if (!isNearScrollBottom(el)) {
      return;
    }
    this.notificationReachBottom();
  }

  /**
   * Prefetches the next page only when the open notification panel does not fill.
   * A closed mat-menu reports 0×0, which used to look like a short list and paged through every notification.
   */
  private maybeLoadMoreNotificationsIfShort(): void {
    setTimeout(() => {
      const el = this.notificationScrollPanel?.nativeElement;
      if (!el || this.notificationLoadingMore || !this.notificationHasMore) {
        return;
      }
      if (!this.menuTrigger?.menuOpen || el.clientHeight <= 0) {
        return;
      }
      if (el.scrollHeight <= el.clientHeight + 1) {
        this.notificationReachBottom();
      }
    });
  }

  /**
   * isShowActionButton
   * @param {*} item
   * @returns {boolean}
   */
  isShowActionButton(item): boolean {
    let flag = false;
    if (
      item.Data?.Action === 'GarageEstimateNotification' &&
      !this.checkClaimPermission('estimate.view') &&
      !this.checkClaimPermission('insurance.viewer')
    ) {
      return false;
    }

    const condition1 =
      [
        'ViewRepairHistory',
        'ViewParts',
        'ClaimSubmitForReview',
        'GarageReAssignment',
        'GarageEstimateNotification',
        'SendIntimationInformation',
        'ViewRepair',
        'ViewStockForReview',
        'ViewEstimate',
        'ViewCreditNote',
        'ViewDebitNote'
      ].indexOf(item.Data?.Action) !== -1;
    const condition2 =
      [
        'SendRequestForRepairInvoice',
        'SendRequestForRepairEstimate',
        'ApprovalRequestResponseFromClaim',
        'EstimateRevisionFromClaim',
        'ClaimRejected',
        'BidirectionalMessage',
        'BookingDelayed',
        'BookingOutDelayed',
        'BookingInDelayed',
        'RepairCreated'
      ].indexOf(item.Type) !== -1;
    const condition3 =
      item.Data !== null && Object.prototype.hasOwnProperty.call(item.Data, 'Action') && item.Data?.Action?.indexOf('ClaimRequest') !== -1;
    const condition4 =
      item.Data !== null && Object.prototype.hasOwnProperty.call(item.Data, 'Action') && item.Data?.Action?.indexOf('IntimationRequest') !== -1;

    const condition5 =
      [
        'SupplierOrderConfirmed',
        'SupplierReturnApprovedRejected',
        'OfferRequestExpired',
        'OfferRequested',
        'SupplierReturnRequested',
        'RepairerLaunchOrder',
        'RepairerCancelOrder'
      ].indexOf(item.Type) !== -1;

    if ((condition1 || condition2 || condition3 || condition4 || condition5) && item.Type !== 'BookingUnassigned') {
      flag = true;
    }

    return flag;
  }

  /**
   * Resolves the translation key for a notification's action button.
   * Action-based mapping takes precedence over Type-based mapping; falls back to 'view_details'.
   * @param item Notification item with optional `Data.Action` and `Type` discriminators.
   * @returns Translation key for the action button label.
   */
  actionButtonText(item): string {
    const actionButtonTextByAction: Readonly<Record<string, string>> = {
      ViewRepairHistory: 'view_repair_history',
      ViewParts: 'view_parts',
      ClaimSubmitForReview: 'view_claim',
      CaseSubmitForReview: 'view_case',
      GarageReAssignment: 'reassign',
      ViewStockForReview: 'view_inventory'
    };

    const actionButtonTextByType: Readonly<Record<string, string>> = {
      SendRequestForRepairInvoice: 'view_invoice',
      ApprovalRequestResponseFromClaim: 'view_estimate',
      EstimateRevisionFromClaim: 'view_estimate',
      RepairEstimateRevisionSentToClaim: 'view_estimate',
      SendRequestForRepairEstimate: 'view_repair',
      ClaimRejected: 'view_repair',
      BidirectionalMessage: 'view_message',
      SendIntimationInformation: 'view_details',
      BookingDelayed: 'view_details',
      BookingOutDelayed: 'view_details',
      BookingInDelayed: 'view_details',
      RepairClaimIntimationApproved: 'view_repair',
      RepairClaimIntimationRejected: 'view_repair'
    };

    return actionButtonTextByAction[item?.Data?.Action] ?? actionButtonTextByType[item?.Type] ?? 'view_details';
  }

  /**
   * claim permission
   * @param permissionName
   */
  checkClaimPermission(permissionName: string): boolean {
    const automotiveService = this.userPermission?.automotiveServices;
    const permissionList = automotiveService?.find(
      x => x.automotiveServiceName.toLowerCase() === 'addenda claims' || x.automotiveServiceName.toLowerCase() === 'claim surveyor'
    )?.permissions;

    return this.commonService.hasPermission(permissionName, permissionList);
  }

  /**
   * show toast
   * @param data
   */
  showWhatsappToast(duration: number, data: any, action?: any): void {
    this._snackBar.openFromComponent(ChatNotificationComponent, {
      data: {
        data,
        action,
        preClose: () => {
          this._snackBar.dismiss();
        }
      },
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: 'whatsapp-notification',
      duration
    });
  }

  /**
   *
   */
  closeNav(isItemSelected): void {
    this.messaging.close();
    if (isItemSelected) {
      this.getGeneralCommunicationMessagesCount();
    }
  }

  /**
   *
   */
  toggleSideMenu(): void {
    this.expandedMenu = !this.expandedMenu;
    if (this.expandedMenu) {
      this.menuIcon = 'menu-expand';
    } else {
      this.menuIcon = 'menu-collapse';
    }
    this.toggle.emit();
  }

  /**
   * function
   */
  getGeneralCommunicationMessagesCount(): void {
    const automotiveService = this.userPermission?.automotiveServices;
    const permissionList = automotiveService?.find(x => x.automotiveServiceName.toLowerCase() === 'addenda repair');
    if (
      permissionList &&
      (permissionList.roleName.toLowerCase() === 'bodyshop manager' || permissionList.roleName.toLowerCase() === 'service advisor')
    ) {
      this.messagesService.getGeneralChatUnreadCount().subscribe((res: any) => {
        this.generalCommunicationMessagesCount = res?.data ?? 0;
            this.changeDetectorRef.markForCheck();
});
    }
  }

  /**
   * onLangChange
   */
  async onLangChange(): Promise<void> {
    const lang = this.options.find(x => x.Code === this.selectedLang);
    if (lang) {
      this.configurationService.languageSettings.selectedLanguage = lang.Code;
      localStorage.setItem('languageSettings', JSON.stringify(this.configurationService.languageSettings));
      localStorage.setItem('languageCode', this.configurationService.languageSettings.selectedLanguage);
      localStorage.setItem('locale', lang.Locale);
      const selectedLanguage = this.configurationService.languageSettings.languageFiles.find(x => x.code === lang.Code);
      if (selectedLanguage) {
        // locale first: screens listening to the translation change re-read geti18nInfo() at that moment
        const newLocale = selectedLanguage.code;
        this.commonService.loadLocaleMessages(newLocale);
        this.commonService.setLocale(lang.Locale);

        if (selectedLanguage.resourceData) {
          await this.configurationService.setTranslation(selectedLanguage.resourceData);
        } else {
          this.commonService.showLoading();
          const remoteLanguageData = await this.configurationService.getTranslation();
          await this.configurationService.setTranslation(remoteLanguageData);
          this.commonService.hideLoading();
        }
      } else {
        await this.configurationService.setTranslation({});
      }
      setTimeout(() => {
        this.changeDetectorRef.detectChanges();
      }, 300);
    } else {
      console.warn('Selected language not found in options:', this.selectedLang);
    }
  }

  /**
   * switch organization
   */
  switchOrganization(): void {
    const selectedOrg = this.userSelectionService.getSelectedOrg();
    const dialogRef = this.userSelectionService.openOrganizationSelectionDialog(selectedOrg, true);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.reloadRoute();
        this.notificationList = [];
        this.notificationGuidList = [];
        this.notificationTotalCount = 0;
        this.getNotificationMessages(0);
        this.getNotificationUnreadCount();
      }
        this.changeDetectorRef.markForCheck();
});
  }

  /**
   * reload route
   */
  reloadRoute(): void {
    const currentUrl = this.router.url;
    let mainRoute = currentUrl;
    if (this.hasGuidInUrl(currentUrl)) {
      mainRoute = currentUrl.split('/').slice(0, 2).join('/');
    } else if (currentUrl.includes('/claim-detail-v2/') || currentUrl.includes('/claim/my-claim?org=')) {
      mainRoute = '/claim/my-claim';
    }
    this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(mainRoute);
    });
  }

  /**
   * check guid
   * @param url
   * @returns
   */
  hasGuidInUrl(url): boolean {
    const guidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;
    return guidRegex.test(url);
  }

  /**
   * navigateToHelpSection
   */
  navigateToHelpSection(): void {
    this.router.navigate([ '/help-section' ]);
  }

  /**
   * Loads AI Studio subscription data and updates the header plan name tag.
   * @param userData user profile payload
   */
  private refreshAiStudioPlanTag(userData: any): void {
    const orgPackages = userData?.userPermission?.orgPackages;
    const hasAiStudioService = this.aiStudioSubscriptionCtaService.hasAiStudioOrgPackage(orgPackages);
    if (!hasAiStudioService) {
      this.showAiStudioPlanTag = false;
      this.aiStudioPlanTagLabel = '';
      return;
    }

    const subscriptionDetails = userData?.subscriptionDetails;
    const labelFromProfile = this.aiStudioSubscriptionCtaService.resolvePlanTagLabel(
      null,
      null,
      subscriptionDetails
    );

    if (labelFromProfile) {
      this.aiStudioPlanTagSubscription?.unsubscribe();
      this.aiStudioPlanTagSubscription = null;
      this.aiStudioPlanTagLabel = labelFromProfile;
      this.showAiStudioPlanTag = true;
      return;
    }

    const tenantId = userData?.tenantId;
    this.aiStudioPlanTagLabel = '';
    this.showAiStudioPlanTag = false;
    if (!tenantId) {
      return;
    }

    this.aiStudioPlanTagSubscription?.unsubscribe();
    this.aiStudioPlanTagSubscription = forkJoin({
      subscription: this.coreService.getTenantSubscription(tenantId).pipe(catchError(() => of(null))),
      usage: this.aiService.getTenantDashboard().pipe(catchError(() => of(null)))
    }).subscribe({
      next: ({ subscription, usage }) => {
        this.aiStudioPlanTagLabel = this.aiStudioSubscriptionCtaService.resolvePlanTagLabel(
          subscription,
          usage,
          subscriptionDetails
        );
        this.showAiStudioPlanTag = !!this.aiStudioPlanTagLabel;
            this.changeDetectorRef.markForCheck();
}
    });
  }

  /**
   * ngOnDestroy
   * unsubscribe subscriptions
   */
  ngOnDestroy(): void {
    this.stopHrmClockInReminder();
    this.stopHrmTicker();
    this.aiStudioPlanTagSubscription?.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
  }

  /** Toggle HRMS check-in / check-out (header). */
  toggleCheckInOut(): void {
    if (!this.showHrmCheckIn) {
      return;
    }
    if (this.isCheckedIn) {
      this.hrmCheckOut();
    } else {
      this.hrmCheckIn();
    }
  }

  /** Load open check-in from API (same rules as attendance page). */
  private fetchHrmCurrentCheckIn(): void {
    if (!this.showHrmCheckIn) {
      return;
    }
    this.commonService.showLoading();
    this.attendanceService.refreshCurrentCheckIn().subscribe({
      next: () => {
        this.commonService.hideLoading();
        // state is broadcast via AttendanceService.checkInState$
      },
      error: () => {
        this.commonService.hideLoading();
        this.isCheckedIn = false;
        this.hasCheckedInToday = false;
        this.resetHrmTotals();
            this.changeDetectorRef.markForCheck();
}
    });
  }

  /** HRMS: clock-in for logged-in user (header). */
  private hrmCheckIn(): void {
    this.commonService.showLoading();
    this.attendanceService.checkIn().subscribe({
      next: () => {
        this.commonService.hideLoading();
        // state is broadcast via AttendanceService.checkInState$
      },
      error: (err) => {
        this.commonService.hideLoading();
        const msg = err?.error?.msg ?? err?.error?.message ?? 'checkin_error';
        this.commonService.showToast(0, msg);
      }
    });
  }

  /**
   * HRMS: clock-out for logged-in user (header). Confirms first - an accidental click was
   * previously irreversible without raising a regularization request.
   */
  private hrmCheckOut(): void {
    this.dialog
      .open(ConfirmDialogComponent, {
        disableClose: false,
        data: {
          title: 'check_out',
          message: 'confirm_check_out_msg',
          okText: 'ok',
          cancelText: 'cancel'
        },
        panelClass: 'custom-dialog',
        width: '300px',
        direction: this.commonService.direction
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          this.performHrmCheckOut();
        }
      });
  }

  /** Handles performHrmCheckOut. */
  private performHrmCheckOut(): void {
    this.commonService.showLoading();
    this.attendanceService.checkOut().subscribe({
      next: () => {
        this.commonService.hideLoading();
        // state is broadcast via AttendanceService.checkInState$
      },
      error: (err) => {
        this.commonService.hideLoading();
        const msg = err?.error?.msg ?? err?.error?.message ?? 'checkout_error';
        this.commonService.showToast(0, msg);
      }
    });
  }

  /** Subscribe to shared AttendanceService check-in state. */
  private subscribeHrmCheckInState(): void {
    const sub = this.attendanceService.checkInState$.subscribe((state) => {
      const wasCheckedIn = this.isCheckedIn;
      this.hrmCheckInState = state;
      this.isCheckedIn = !!state?.isCheckedIn;
      this.canCheckIn = !!state?.canCheckIn;
      this.canCheckOut = !!state?.canCheckOut;
      if (typeof state?.hasCheckedInToday === 'boolean') {
        this.hasCheckedInToday = state.hasCheckedInToday;
      } else if (wasCheckedIn && !this.isCheckedIn) {
        // On checkout transitions, missing payload flag should still count as checked-in-today.
        this.hasCheckedInToday = true;
      }
      this.syncHrmClockInReminder();
      this.refreshHrmTotals();
        this.changeDetectorRef.markForCheck();
});
    this.subs.push(sub);
  }

  /**
   * Re-derives both totals from the state's absolute timestamps, then starts or stops the ticker.
   *
   * Replaces pushing a seconds count into an `xa-timer` held by `@ViewChild` and calling
   * start()/stop() on it. That widget lives inside the header's `*ngIf`, so opening the search bar
   * destroyed it and the replacement instance was never restarted - the clock froze until the next
   * punch. Owning the string here removes the view dependency altogether.
   */
  private refreshHrmTotals(): void {
    const state = this.hrmCheckInState;
    this.effectiveDisplay = AttendanceService.formatDuration(this.attendanceService.effectiveSecondsAt(state));
    this.grossDisplay = AttendanceService.formatDuration(this.attendanceService.grossSecondsAt(state));

    // Only a running session makes the totals move; once every session is closed they are final,
    // so the ticker is stopped rather than left spinning against an unchanging answer.
    if (state?.currentSessionStartUtc) {
      this.startHrmTicker();
    } else {
      this.stopHrmTicker();
    }
    this.changeDetectorRef.markForCheck();
  }

  /** Clears the widget back to zero (no HRMS access, or the status call failed). */
  private resetHrmTotals(): void {
    this.hrmCheckInState = null;
    this.refreshHrmTotals();
  }

  /** Handles startHrmTicker. */
  private startHrmTicker(): void {
    if (this.hrmTickTimer) {
      return;
    }
    this.hrmTickTimer = setInterval(() => this.refreshHrmTotals(), 1000);
  }

  /** Handles stopHrmTicker. */
  private stopHrmTicker(): void {
    if (!this.hrmTickTimer) {
      return;
    }
    clearInterval(this.hrmTickTimer);
    this.hrmTickTimer = null;
  }

  /** Restrict reminder popup to required repair roles only. */
  private isHrmCheckInReminderRoleEligible(): boolean {
    return ![ 'technician' ].includes(String(this.commonService.roleName || '').toLowerCase());
  }

  /** Start/stop one-time 5-minute reminder based on check-in state. */
  private syncHrmClockInReminder(): void {
    if (
      !this.showHrmCheckIn ||
      !this.isHrmCheckInReminderRoleEligible() ||
      this.hasShownHrmCheckInReminder ||
      this.hasCheckedInToday ||
      this.isCheckedIn
    ) {
      this.stopHrmClockInReminder();
      return;
    }

    if (this.hrmCheckInReminderTimer) {
      return;
    }

    this.hrmCheckInReminderTimer = setTimeout(() => {
      this.hrmCheckInReminderTimer = null;
      if (
        !this.isCheckedIn &&
        !this.hasCheckedInToday &&
        this.showHrmCheckIn &&
        this.isHrmCheckInReminderRoleEligible() &&
        !this.hasShownHrmCheckInReminder
      ) {
        this.hasShownHrmCheckInReminder = true;
        this.commonService.showInfoToast(5000, this.translateService.instant('hrm_clock_in_reminder_5min'));
      }
    }, HRM_CLOCK_IN_REMINDER_DELAY_MS);
  }

  /** Clear pending reminder timer. */
  private stopHrmClockInReminder(): void {
    if (!this.hrmCheckInReminderTimer) {
      return;
    }
    clearTimeout(this.hrmCheckInReminderTimer);
    this.hrmCheckInReminderTimer = null;
  }

  /**
   *
   * @param url
   */
  private getTitleFromMenuItems(url: string, event: NavigationEnd): void {
    if (url.includes('?')) {
      url = url.substring(0, url.lastIndexOf('?'));
    }
    const lowerUrl = url.toLowerCase();

    this.tabMenus.forEach(x => (x.active = false));
    this.parentTitle = '';
    this.showTabMenus = url.includes('/quote/case/');
    const exactMatch = this.partialUrlsMatch.find(item => item.partialUrl === url);
    // const partialUrlMatchData = exactMatch ?? this.partialUrlsMatch.find(item => url.includes(item.partialUrl));
    // if (partialUrlMatchData?.title) {
    //   this.title = partialUrlMatchData.title;
    //   this.subTitle = partialUrlMatchData.subTitle;
    //   this.parentTitle = partialUrlMatchData.parentTitle;
    //   this.pageDescription = partialUrlMatchData.pageDescription ?? null;
    //   this.icon = partialUrlMatchData.icon;
    //   this.commonService.updatePage(this.title, this.subTitle);
    //   return;
    // }

    const partialCandidates = this.partialUrlsMatch.filter(item => url.indexOf(item.partialUrl) !== -1);
    const partialUrlMatchData = exactMatch ? exactMatch : [ ...partialCandidates ].sort((a, b) => b.partialUrl.length - a.partialUrl.length)[0];
    if (partialUrlMatchData?.title) {
      this.title = partialUrlMatchData.title;
      this.subTitle = partialUrlMatchData.subTitle;
      this.parentTitle = partialUrlMatchData.parentTitle;
      this.pageDescription = partialUrlMatchData.pageDescription ?? null;
      this.icon = partialUrlMatchData.icon;
      this.commonService.updatePage(this.title, this.subTitle);
      return;
    }

    this.pageDescription = null;
    this.caseId = url.split('/quote/case/')[1] ? url.split('/quote/case/')[1].split('/')[0] : null;

    this.commonService.caseId.next(this.caseId);
    const menuMatch = this.findMenuItemByUrl(url, this.menuItems);
    if (menuMatch) {
      this.setPageFromMenu(menuMatch.matchedItem, menuMatch.rootItem);
    } else {
      if (lowerUrl.includes('/quote/case/')) {
        const menuItem = this.menuItems?.find((obj) => {
          return obj.childMenu?.some((child: menuItem) => child.url === '/quote/case/0');
        });
        if (menuItem) {
          const childMenuItem = menuItem.childMenu?.find(x => x.url === '/quote/case/0');
          if (childMenuItem) {
            this.title = childMenuItem.title;
            this.subTitle = childMenuItem.subTitle;
            this.icon = menuItem.icon ?? 'home';
          }
        }
      } else if (url === '/repair/booking/0') {
        const menuItem = this.repairMenuItem();
        this.title = 'add_customer';
        this.subTitle = menuItem?.subTitle ?? 'repair';
        this.icon = menuItem?.icon ?? 'home';
      } else if (lowerUrl.includes('/repair/booking/')) {
        const menuItem = this.repairMenuItem();
        if (lowerUrl.includes('/parts') || lowerUrl.includes('/repair-stages') || lowerUrl.includes('/invoices')) {
          this.title = 'repair_details';
        } else {
          this.title = 'booking_details';
        }
        this.subTitle = menuItem?.subTitle ?? 'repair';
        this.icon = menuItem?.icon ?? 'home';
      } else if (lowerUrl.includes('/repair/customers/')) {
        const menuItem = this.menuItems?.find((obj) => {
          return obj.childMenu?.some((child: menuItem) => child.url === '/repair/customers/company');
        });
        const childMenuItem = menuItem.childMenu?.find(x => x.url === '/repair/customers/company');
        this.title = childMenuItem.title;
        this.subTitle = childMenuItem.subTitle;
        this.icon = menuItem.icon ?? 'home';
      } else if (
        url === '/settings/repair-type' ||
        url === '/settings/jobs-tasks' ||
        url === '/settings/scheduling' ||
        url === '/settings/calendar' ||
        url === '/settings/target' ||
        url === '/settings/operations' ||
        url === '/settings/repair-cost-setting'
      ) {
        const menuItem = this.menuItems?.find(x => x.url === '/settings');
        this.title = menuItem.title;
        this.subTitle = menuItem.subTitle;
        this.icon = menuItem.icon ?? 'home';
      } else if (lowerUrl.includes('/claim/')) {
        const menuItem = this.menuItems?.find(x => x.name === 'claim');

        this.title = 'claim';
        if (lowerUrl.includes('/claim-edit/')) {
          this.title = 'file_a_claim';
          if (event instanceof NavigationEnd) {
            const urlTree = this.router.parseUrl(event.urlAfterRedirects);
            const queryParams = urlTree?.queryParams;

            if (queryParams) {
              if (queryParams['mode'] === 'edit') {
                this.title = 'edit_claim';
              }
            }
          }
        } else if (lowerUrl.includes('/mirsaas-claim-registration')) {
          this.title = 'file_a_claim';
        } else if (lowerUrl.includes('/estimate')) {
          this.title = 'my_claim';
        } else if (url === '/claim') {
          this.title = menuItem.defaultChildMenu;
        } else if (lowerUrl.includes('/garages/')) {
          this.title = 'garages';
        } else if (lowerUrl.includes('customer-satisfaction')) {
          this.title = 'claim_dashboard';
        } else if (lowerUrl.includes('garages-dashboard')) {
          this.title = 'claim_dashboard';
        } else {
          this.title = 'my_claim';
        }
        this.subTitle = menuItem.subTitle;
        this.icon = menuItem.icon ?? 'home';
      } else if (lowerUrl.includes('/repair/technician-calendar')) {
        this.title = 'technician_calendar';
        this.subTitle = 'repair';
      } else if (lowerUrl.includes('/home/dashboard/')) {
        this.title = 'dashboard';
        this.subTitle = 'home';
      } else if (lowerUrl.includes('repairer-view')) {
        //repairer-view check
        if (lowerUrl.includes('dashboard/customers')) {
          const menuItem = this.menuItems?.find(x => x.url === '/repairer-view/dashboard/general');
          this.title = menuItem.title;
          this.subTitle = menuItem.subTitle;
          this.icon = menuItem.icon ?? 'home';
        } else if (lowerUrl.includes('/estimate')) {
          this.title = 'Repairer View';
          this.subTitle = 'estimate';
        } else if (lowerUrl.includes('/photo')) {
          this.title = 'Repairer View';
          this.subTitle = 'photos';
        } else if (lowerUrl.includes('/document')) {
          this.title = 'Repairer View';
          this.subTitle = 'documents';
        } else {
          this.title = 'Repairer View';
          this.subTitle = 'customer';
        }
      } else if (url === '/settings/estimate/tax' || url === '/settings/estimate/invoice' || url === '/settings/estimate/estimate') {
        const menuItem = this.menuItems.find(x => x.url === '/settings');
        if (menuItem) {
          const childMenuItem = menuItem.childMenu?.find(x => x.url === '/settings/estimate/tax');
          if (childMenuItem) {
            this.title = childMenuItem.title;
            this.subTitle = childMenuItem.subTitle;
            this.icon = menuItem.icon ?? 'home';
          }
        }
      } else if (lowerUrl.includes('/settings/service-configuration/category/')) {
        const menuItem = this.menuItems.find(x => x.name === 'settings');
        const childMenuItem = menuItem.childMenu?.find(x => x.name === 'service_config');
        this.title = 'service_configuration';
        this.subTitle = childMenuItem.subTitle;
      } else {
        this.title = 'dashboard';
        this.subTitle = 'home';
        this.icon = 'home';
      }
    }

    if (url === '/hrm/payroll-structure/create' || lowerUrl.includes('/hrm/payroll-structure/create')) {
      this.title = 'payroll';
      this.subTitle = 'hrm';
      this.icon = 'home';
    } else if (lowerUrl.includes('/hrm/payroll-runs/') && lowerUrl.includes('/workflow')) {
      this.title = 'payroll_run_workflow_title';
      this.subTitle = 'hrm';
      this.icon = 'home';
    }
  }

  /**
   * The Repair menu item. Found by name: the side menu replaces a parent's `url` ('/repair') with its first permitted
   * child's url (e.g. '/repair/booking-journal').
   */
  private repairMenuItem(): menuItem | undefined {
    return this.menuItems?.find(x => x.name === 'repair');
  }
}
